<template v-slot:append>
  <v-dialog max-width="75%" persistent no-click-animation
      v-bind="computedProps"
      v-on="computedListeners"
      v-model="showDialog">
    <v-card min-height="75%" min-width="75%">
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer/>
        <v-toolbar-title>
          {{ title }}
        </v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
          <dd-sub-header>
              検索条件
          </dd-sub-header>
          <v-row no-gutters align-content="center">
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col class="px-1">
                  <dd-code-text-box
                    label="受注営業所コード/名称"
                    v-model="conditions.juchuEigyoshoCd"
                    ref="juchuEigyoshoCd"
                    :required=false
                    :length=100
                    :valueType="ctypes.InputTypes.Free"
                    :itemList="filteredEigyoshoList"
                    titleText="営業所検索"
                    item-value="eigyoshoCd"
                    item-text="eigyoshoNm"
                    :headerList="eigyoshoHeader"
                    />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col :cols="6" class="px-1">
                  <dd-date-box
                            hint="開始"
                               label="受注日"
                               v-model="conditions.juchuStartYmdString"
                               ref="juchuStartYmdString"
                               :length="10"
                               :required="false"
                               :valueType="ctypes.InputTypes.Date"/>
                </v-col>
                <v-col :cols="6" class="px-1">
                  <dd-date-box
                             hint="終了"
                               v-model="conditions.juchuEndYmdString"
                               ref="juchuEndYmdString"
                               :length="10"
                               :required="false"
                               :valueType="ctypes.InputTypes.Date"/>
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col class="px-1">
                  <dd-code-text-box
                    label="受注担当者コード/名称"
                    :required=false
                    v-model="conditions.insUserCd"
                    ref="insUserCd"
                    :length=100
                    :valueType="ctypes.InputTypes.Free"
                    :itemList="filteredJininList"
                    titleText="担当者検索"
                    item-value="jininCd"
                    item-text="jininNm"
                    :headerList="jininHeader"
                    />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters align-content="center">
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col class="px-1">
                  <dd-code-text-box
                    label="取引先コード/名称"
                    :required=false
                    v-model="conditions.tokuisakiCd"
                    ref="tokuisakiCd"
                    :length=100
                    :valueType="ctypes.InputTypes.Free"
                    :itemList="filteredTorihikisakiList"
                    titleText="取引先検索"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    :headerList="torihikisakiHeader"
                    />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                <v-col :cols="6" class="px-1">
                  <dd-date-box
                            hint="開始"
                              label="請求予定日"
                              v-model="conditions.seikyuStartYmdString"
                              ref="seikyuStartYmdString"
                              :length="10"
                              :required="false"
                              :valueType="ctypes.InputTypes.Date"
                              />
                </v-col>
                <v-col :cols="6" class="px-1">
                  <dd-date-box
                            hint="終了"
                              v-model="conditions.seikyuEndYmdString"
                              ref="seikyuEndYmdString"
                              :length="10"
                              :required="false"
                              :valueType="ctypes.InputTypes.Date"
                              />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="4">
              <v-row no-gutters align-content="center">
                  <v-toolbar class="pa-0 ma-0" flat dense>
                      <v-spacer />
                      <dd-default-button
                          class="ml-2"
                          dark
                          dense
                          @click="onSearchButtonClick">
                          検索
                      </dd-default-button>
                      <dd-default-button
                          class="ml-2"
                          dark
                          dense
                          @click="onClearButtonClick">
                          クリア
                      </dd-default-button>
                  </v-toolbar>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="6">
              <dd-sub-header>
                一覧
              </dd-sub-header>
            </v-col>
            <v-col :cols="1"></v-col>
            <v-col :cols="3">
              <dd-narrow-down-text-box v-model="searchText" :length=10 />
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                    label="検索結果"
                    v-model="rowCount"/>
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                    label="絞込結果"
                    v-model="filteredRowCount"/>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="12">
              <dd-data-table
                v-model="selectedItem"
                calculate-widths
                height="25vh"
                item-key="juchuKihonId"
                showSelect
                singleSelect
                @dblclick:row="onRowDoubleClick"
                @click:row="onRowClick"
                :headers="headers"
                :items="filteredRows"
                :search="searchText"
                :loading="loading"
                :header-props="{sortByText: '並び替え'}"
                :footer-props="{'items-per-page-options': [100, 200, 300, 400, 500],showFirstLastPage: true,}"
                loading-text="検索中のため、少々お待ちください。"
                items-per-page=100
                :itemsPerPage=100
                fixed-header
                locale="ja-jp"
                no-data-text="利用可能なデータはありません。"
                dense
                :page.sync ="page"
                />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <dd-footer-button
          @click="onCloseClick">
          閉じる
        </dd-footer-button>
        <v-spacer></v-spacer>
        <dd-footer-button
          :disabled="isSelectButtonDisabled"
          @click="onSelectButtonClick">
          選択
        </dd-footer-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DdSubHeader from '@/components/DdSubHeader'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'

import controls from '@/rahmen/controls'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'
import validators from '@/rahmen/validators'

import { mapGetters } from 'vuex'

export default {
  name: 'DdV2JutyuKensakuDialog',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdFooterButton,
    DdDataTable,
    DdRowCountBox,
    DdCodeTextBox,
    DdDateBox,
    DdDefaultButton,
    DdNarrowDownTextBox
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * ダイアログタイトル
     */
    titleText: String
  },
  data: () => ({
    conditions: {
      juchuEigyoushoCd: '',
      juchuStartYmdString: '',
      juchuEndYmdString: '',
      nyuryokuTantoushaCd: '',
      tokuisakiCd: '',
      seikyuStartYmdString: '',
      seikyuEndYmdString: ''
    },
    searchText: '',
    title: '受注検索',
    ctypes: controls,
    /**
     * 一覧内容
     */
    rows: [],
    loading: false,
    selectedItem: [],
    page: 1
  }),
  created () {
    console.log('screen created')
    // this.calcHeightTargets = ['calcRow1', 'calcRow2', 'calcRow3", "calcFooter']
    // this.Effects.loadStart()
    this.$store.dispatch('system/setViewTitle', '受注検索')
    this.eigyoshoHeader = header.mstEigyoshoHeaders
    this.torihikisakiHeader = header.mstTorihikisakiHeaders
    this.jininHeader = header.mstJininHeaders
    /*
    this.eigyoshoHeader = [
      { width: '60px', text: '営業所コード', value: 'eigyoshoCd' },
      { width: '90px', text: '営業所名', value: 'eigyoshoNm' }
    ]
    this.torihikisakiHeader = [
      { width: '60px', text: '取引先コード', value: 'torihikisakiCd' },
      { width: '90px', text: '取引先名', value: 'torihikisakiNm' }
    ]
    this.jininHeader = [
      { width: '60px', text: '担当者コード', value: 'jininCd' },
      { width: '90px', text: '担当者姓', value: 'jininNmSei' },
      { width: '90px', text: '担当者名', value: 'jininNmMei' }
    ]
    */
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      jininList: 'DDMasters/mstJinin',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho'
    }),
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        return elem1.hyojiOrder - elem2.hyojiOrder
      })
    },
    filteredTorihikisakiList () {
      // 取引先全部
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        return elem1.hyojiOrder - elem2.hyojiOrder
      })
    },
    filteredJininList () {
      const target = filter.dateFormatter(new Date())
      return this.jininList.map((elem) => {
        elem.jininNm = elem.jininNmSei + (elem.jininNmMei ? ' ' + elem.jininNmMei : '')
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        return elem1.hyojiOrder - elem2.hyojiOrder
      })
    },
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        maxWidth: '80%'
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    filteredRows () {
      return this.rows.map((elem) => {
        elem.juchuYmdDisp = filter.dateFormatter(elem.juchuYmd) ?? ''
        elem.seikyuYoteiYmdDisp = filter.dateFormatter(elem.seikyuYoteiYmd) ?? ''
        elem.seikyuKingakuDisp = filter.numericFormatter(elem.seikyuKingaku)
        elem.juchuEigyoshoNmDisp = elem.juchuEigyoshoCd + ' ' + elem.juchuEigyoshoNm
        elem.tokuisakiNmDisp = elem.tokuisakiCd + ' ' + elem.tokuisakiNm
        return elem
      })
    },
    isSelectButtonDisabled () {
      return this.selectedItem.length === 0
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const opt = {
        loadMasters: ['mstjinin', 'msttorihikisaki', 'msteigyosho'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('JyutyuKensakuDialog.defineHeaderPromise')
            this.headers = [
              { text: '受注番号', value: 'juchuNo' },
              { text: '受注日', value: 'juchuYmdDisp', align: 'center' },
              { text: '受注営業所', value: 'juchuEigyoshoNmDisp' },
              { text: '取引先', value: 'tokuisakiNmDisp' },
              { text: '請求区分', value: 'seikyuKbn' },
              { text: '請求予定日', value: 'seikyuYoteiYmdDisp', align: 'center' },
              { text: '請求ステータス', value: 'seikyuStatusNm' },
              { text: '請求金額', value: 'seikyuKingakuDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          this.clear(false)
        },
        savedInputRestorePromise: (c) => {
          console.log('JyutyuKensakuDialog.savedInputRestorePromise', c)
          return new Promise(resolve => {
            this.loadFromCacheById('VwCD2comd0030')
              .then((c) => {
                console.log('JyutyuKensakuDialog.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('JyutyuKensakuDialog.researchPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.onSearchButtonClick()
            // this.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('JyutyuKensakuDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('JyutyuKensakuDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            resolve()
          })
        },
        getCloneTargetMethod: function () {
          return {
            conditions: this.conditions
          }
        }
      }
      this.initializeForViewer(opt)
    },
    onRowDoubleClick: function (e, f) {
      /**
       * 選択時クローズ処理
       * @event doubleClick
       * @type {Event}
       */
      console.log('row double clicked', e)
      console.log('row double clicked', f)
      this.$emit('close', f.item)
      this.clear(false)
    },
    onRowClick: function (e) {
      /**
       * 選択処理
       * @event Click
       * @type {Event}
       */
      console.log('row clicked', e, this.searchText)
      this.selectedItem = [e]
      /*
      if (this.selectedItem.length === 0) {
        this.selectedItem = [e]
      } else {
        this.selectedItem = []
      }
      */
    },
    onSelectButtonClick: function (e) {
      /**
       * 選択ボタン押下処理
       * @event click
       * @type {Event}
       */
      console.log('select clicked', e, this.selectedItem)
      if (this.selectedItem.length === 0) {
        this.$emit('close', undefined)
      } else {
        this.$emit('close', this.selectedItem[0])
      }
      this.clear(false)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2comd0030/Search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChacheById('VwCD2comd0030', cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    // onSearchButtonClick: function (e) {
    //   /**
    //    * 検索ボタン押下処理
    //    * @event click
    //    * @type {Event}
    //    */
    //   const isValid = this.validateAll(this.$refs)
    //   console.log('validate all ', isValid)
    //   if (isValid) {
    //     console.log('serach clicked')
    //     this.search()
    //   }
    // },
    // search: function () {
    //   console.log('serach process')
    //   const self = this
    //   self.loading = true
    //   self.HttpClient
    //     .post('/api/v1/VwCD2comd0030/Search', self.conditions)
    //     .then((data) => {
    //       self._setMessages(data).then(() => {
    //         if (!data.isValid) {
    //           self.loading = false
    //           return
    //         }

    //         self.rows = data.payload

    //         self.saveToChache('VwCD2comd0030', { rows: self.rows, conditions: self.conditions })
    //           .then(() => {
    //             self.loading = false
    //           })
    //       })
    //     }).catch(function (error) {
    //       console.log('post error')
    //       console.log(error)
    //       self.loading = false
    //     })
    // },
    clear: function (isRemainRows) {
      console.log('clear', this.torihikisakiList)
      return new Promise(resolve => {
        this.conditions = {
          juchuEigyoshoCd: '',
          juchuStartYmdString: '',
          juchuEndYmdString: '',
          insUserCd: '',
          tokuisakiCd: '',
          seikyuStartYmdString: '',
          seikyuEndYmdString: ''
        }
        if (!isRemainRows) {
          this.rows = []
          this.searchText = ''
          this.selectedItem = []
        }
        resolve()
      })
    },
    clearExec: function () {
      console.log('clearExec')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            console.log('clearExec ...')

            this.conditions = {
              juchuEigyoshoCd: '',
              juchuStartYmdString: '',
              juchuEndYmdString: '',
              insUserCd: '',
              tokuisakiCd: '',
              seikyuStartYmdString: '',
              seikyuEndYmdString: ''
            }
            this.rows = []
            this.searchText = ''
            this.selectedItem = []
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      /**
       * クリアボタン押下処理
       * @event click
       * @type {Event}
       */
      this.Effects.loadStart()
      this.clearExec()
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.$emit('close', undefined)
      console.log('emited', this.showDialog)
      this.clear(false)
    },
    searchValidate: function () {
      var msg
      if (this.conditions.juchuStartYmdString && this.conditions.juchuEndYmdString) {
        msg = validators.compareDate(this.conditions.juchuStartYmdString, this.conditions.juchuEndYmdString)
        if (msg !== undefined) {
          this.$refs.juchuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.juchuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.conditions.seikyuStartYmdString && this.conditions.seikyuEndYmdString) {
        msg = validators.compareDate(this.conditions.seikyuStartYmdString, this.conditions.seikyuEndYmdString)
        if (msg !== undefined) {
          this.$refs.seikyuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.seikyuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      return true
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 400 !important;
}
</style>
